import React, { FC, useMemo } from "react";
import { PaneSizeContext } from "./PaneSizeContext";
import { resolveSizeClassFromPixels } from "./SizeClass";
import { PaneSize } from "./PaneSize";

export interface PaneSizeProviderProps {
  width: number | undefined;
  height: number | undefined;
  children: React.ReactNode;
}

export const PaneSizeProvider: FC<PaneSizeProviderProps> = (props) => {
  const value: PaneSize | null = useMemo(() => {
    if (props.width === undefined || props.height === undefined) {
      return null;
    }
    return {
      width: resolveSizeClassFromPixels(props.width),
      height: resolveSizeClassFromPixels(props.height),
    };
  }, [props.height, props.width]);

  return (
    <PaneSizeContext.Provider value={value}>
      {props.children}
    </PaneSizeContext.Provider>
  );
};
